export enum processTemplates {
    tanderProcess = 'TanderProcess',
    tanderProcessCeded = 'TanderProcessCeded',
    tanderCededWithSourceValidation = 'TanderCededWithSourceValidation',
    tanderProcessDiscount = 'TanderProcessDiscount',
    fundedCessionsProcess = 'FundedCessionsProcess',

    dixyProcess = 'DixyProcess',
    dixyAcceptedProcess = 'DixyAcceptedProcess',
    dixyApprovedProcess = 'DixyApprovedProcess',

    discountProcess = 'ProcessDiscountNG',

    conveyorProcess = 'ConveyorProcess',
    paymentDistributionProcess = 'ProcessPaymentDistr',
    verifiedProcess = 'VerifiedProcess',

    victoriaProcessCeded = 'VictoriaProcessCeded',

    mtsProcessCeded = 'MtsProcessCeded',

    approvedProcess = 'ApprovedProcessNG',

    mtsApprovedProcess = 'MtsApprovedProcess',
    rtkFundedCessionsProcess = 'RtkFundedCessionsProcess',
    mtsFundedCessionsProcess = 'MtsFundedCessionsProcess',
    approvedOrderProcess = 'ApprovedOrderProcessMts',

    epApprovedProcess = 'EpApprovedProcess',

    sperProcessCeded = 'SperProcessCeded',
}

export const dixyAcceptedProcessTemplates = [
    processTemplates.dixyProcess,
    processTemplates.dixyAcceptedProcess,
];

export const dixyApprovedProcessTemplates = [
    processTemplates.dixyProcess,
    processTemplates.dixyApprovedProcess,
];

export const tanderProcessTemplates = [
    processTemplates.tanderProcess,
    processTemplates.tanderProcessCeded,
    processTemplates.tanderCededWithSourceValidation,
];
